// overloads
function toFixed1(value: number): number
function toFixed1(value: null): null
function toFixed1(value: number | null): number | null

// implementation
function toFixed1(value: number | null): number | null {
  if (value === null) {
    return null
  }
  return parseFloat(value.toFixed(1))
}

export default toFixed1